<div
  class="hx-segment-body"
  [attr.aria-hidden]="position() !== 0"
  [attr.inert]="position() !== 0 ? '' : null"
  [attr.role]="'tabpanel'"
  [attr.tabindex]="contentTabIndex()">
  <div
    class="hx-segment-body-content"
    [class.hx-segment-body-content-center]="position() === 0"
    [class.hx-segment-body-content-left]="position() < 0"
    [class.hx-segment-body-content-right]="position() > 0">
    @if (shouldRender()) {
      <ng-template [cdkPortalOutlet]="content()" />
    }
  </div>
</div>
